<template>
  <v-card dark>
    <v-img
      :src="require('@/assets/blurcamera.jpg')"
      class="grey lighten-2"
      height="250"
      width="100%"
    >
      <!-- <v-row class="fill-height pa-3" align="center">
        <v-col cols="12" md="7" offset-md="4">
          <h1 class="display-3 font-weight-light">Impara dai migliori</h1>

          <div class="subheading text-uppercase pl-2 mb-4">Discuti, testa ed impara insieme a loro</div>

          <v-btn color="primary" depressed>INIZIA ORA</v-btn>
        </v-col>
      </v-row>-->
      <v-row class="fill-height pa-3 text-center d-flex align-center">
        <v-col class cols="12">
          <h3 class="mb-4 display-1">Impara dai migliori</h3>
          <p class="font-weight-light title mb-8">Discuti, testa ed impara insieme a loro</p>
          <v-btn color="primary" to="/signup" class="mt-4" v-if="!user" depressed>INIZIA ORA</v-btn>
        </v-col>
      </v-row>
    </v-img>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "HomeBanner",

  computed: {
    ...mapGetters({
      user: "user"
    })
  }
};
</script>
